'use client';

import { clsx as cx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import { Tooltip } from '@/components/tooltip';
import { joinSgcmMedia } from '@/utils/url/join/public';

import { rankMap } from '../config';
import {
  GRADE_TO_POINT_LINK,
  ICON_SIZE_IN_PIXEL,
  RANKING_DESCRIPTION,
} from '../constant';
import styles from '../styles.module.scss';

export const RankTooltipContent = () => (
  <Tooltip
    className={cx(
      styles.containerTooltip,
      styles.containerGradeTooltip,
    )}
    content={(
      <div className={cx(
        styles.containerTooltipContent,
      )}>
        <div className={
          styles.containerRankToolTip
        }>
          <div className={
            styles.textTooltipTitle
          }>
            {RANKING_DESCRIPTION}
          </div>
          <div>
            <table className={
              styles.containerRankTable
            }>
              <colgroup>
                <col style={{ width: '50%' }} />
                <col style={{ width: '50%' }} />
              </colgroup>
              <thead>
                <tr className={
                  styles.containerRankTableHead
                }>
                  <th className={
                    styles.contentRankTable
                  }>
                    Ranks
                  </th>
                  <th className={
                    styles.contentRankTable
                  }>
                    Points
                  </th>
                </tr>
              </thead>
              <tbody>
                {rankMap.map((
                  { rank, points },
                ) => (
                  <tr
                    key={rank}
                    className={
                      styles
                        .containerRankTableBody
                    }>
                    <td className={
                      styles.contentRankTable
                    }>
                      {rank}
                    </td>
                    <td className={
                      styles.contentRankTable
                    }>
                      {'> '}
                      {points}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            More about the
            ranking system click
            {' '}
            <Link
              className={
                styles.rankToolTipHereLink
              }
              href={GRADE_TO_POINT_LINK}
              target="_blank">
              here
            </Link>
            <span>
              .
            </span>
          </div>
        </div>
      </div>
    )}>
    <button
      className={
        styles.buttonRecommendedPriceDesc
      }>
      <Image
        alt="info outline icon image"
        className={cx(
          styles.imageHoverIcon,
        )}
        height={ICON_SIZE_IN_PIXEL}
        src={`${joinSgcmMedia('/public/new-cars/icon/iconOutlineInfo.svg')}`}
        width={ICON_SIZE_IN_PIXEL} />
    </button>
  </Tooltip>
);
